import { LOCAL } from "@mn/shared";
import type * as Y from "yjs";
import { useBoard } from "../BoardContext";
import { useBoardUI } from "../store";

export function SwatchBody({ id, ymap, hex }: { id: string; ymap: Y.Map<unknown>; hex: string }) {
  const { handle, canEdit } = useBoard();
  const editing = useBoardUI((s) => s.editingId === id);
  return (
    <div className="relative flex h-full min-h-[80px] w-full flex-col">
      <div className="flex-1 rounded-t-[4px]" style={{ background: hex }} />
      <div className="bg-panel px-2 py-1 text-center font-mono text-[12px] uppercase text-muted">
        {editing && canEdit ? (
          <input
            autoFocus
            defaultValue={hex}
            onPointerDown={(e) => e.stopPropagation()}
            onBlur={(e) => {
              const v = e.target.value.trim();
              if (/^#[0-9a-fA-F]{6}$/.test(v))
                handle.doc.transact(() => ymap.set("hex", v.toLowerCase()), LOCAL);
              useBoardUI.getState().setEditing(null);
            }}
            onKeyDown={(e) => e.key === "Enter" && (e.target as HTMLInputElement).blur()}
            className="w-full bg-transparent text-center outline-none"
          />
        ) : (
          hex
        )}
      </div>
    </div>
  );
}
